export enum ValidationStatus {
  default = "default",
  error = "error",
  success = "success",
  warning = "warning",
}
